export default __webpack_public_path__ + "static/media/FoodChainDesert_04.eede8c54.png";